module.exports = {"id":"id","name":"name","air_date":"air date","episode":"episode","characters":"characters"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/episode_properties.json
// module id = 24
// module chunks = 0